<div class="user-avatar-container">
    @if (showShadow) {
        <div class="user-avatar-shadow"></div>
    }
    <div
        class="user-avatar"
        title="{{ user.firstName }} {{ user.lastName }}"
        [class]="getBackgroundColor() + '-bg'"
        [class.last]="lastUser"
    >
        @if (user.avatar !== undefined && user.avatar !== null && user.avatar.length > 0) {
            <img src="{{ user.avatar }}" width="36" height="36" />
        } @else {
            <span>{{ getInitials() }}</span>
        }
    </div>
</div>
